import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseDesc, BaseTitle, BaseContainer, BaseImage,
} from './styles';

const vPadding = 140;
const Container = styled(BaseContainer)`
  margin-top: ${vPadding + 8}px;
  ${props => (!props.theme.isMobile && `
    margin-bottom: ${vPadding + 8}px;
  `)};
`;

const Title = styled(BaseTitle)`
  max-width: 493px;
`;

const Description = styled(BaseDesc)`
  margin-top: 30px;
`;

export default function TrendingContent() {
  const { trending, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#trending', vPadding);

  return (
    <Container id="trending">
      <Plx className="left-section" parallaxData={plxData.text} disabled={isMobile}>
        <SectionName>Features</SectionName>
        <Title>Receive trending content direct to your inbox</Title>
        <Description>
          We curate the best of the website each day and send it to you in a single email so you
          can stay dialled in to what the experts are saying about the markets.
        </Description>
      </Plx>
      <Plx className="base-section" parallaxData={plxData.image} disabled={isMobile}>
        <BaseImage src={trending} />
      </Plx>
    </Container>
  );
}
